// Shared Components
import ShopifySectionsManager from '@pixelunion/shopify-sections-manager';
import rimg from 'rimg-shopify';
import PxsMap from '@pixelunion/pxs-map';
import scriptjs from 'scriptjs';

// Utils
import './utils/jquery';
import Rte from './utils/Rte';
import ThemeUtils from './utils/ThemeUtils';
import polyfillUrls from './utils/checkPolyfills';

// Templates
import TemplateAccount from './templates/TemplateAccount';
import TemplateCollection from './templates/TemplateCollection';
import TemplateGiftCard from './templates/TemplateGiftCard';
import TemplatePassword from './templates/TemplatePassword';
import TemplateSearch from './templates/TemplateSearch';

// Sections
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicVideo from './sections/DynamicVideo';
import StaticCart from './sections/StaticCart';
import StaticProduct from './sections/StaticProduct';
import StaticProductRecommendations from './sections/StaticProductRecommendations';

// Components
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import AnnouncementBar from './components/AnnouncementBar';

rimg.init('[data-rimg="lazy"]', { round: 1 });

const initPacific = () => {
  window.ThemeUtils = ThemeUtils;
  const el = document.body;

  // Common views
  const sections = new ShopifySectionsManager();

  sections.register('header', section => new Header(section), { lazy: true });
  sections.register('footer', section => new Footer(section), { lazy: true });
  sections.register('slideshow', section => new DynamicSlideshow(section), { lazy: true });
  sections.register('featured-video', section => new DynamicVideo(section), { lazy: true });
  sections.register('pxs-map', section => new PxsMap(section), { lazy: true });
  sections.register('featured-product', section => new StaticProduct(section), { lazy: true });
  sections.register('page-product', section => new StaticProduct(section), { lazy: true });
  sections.register('static-product-recommendations', section => new StaticProductRecommendations(section), { lazy: true });
  sections.register('page-collection', section => new TemplateCollection(section), { lazy: true });
  sections.register('page-cart', section => new StaticCart(section), { lazy: true });
  sections.register('pxs-announcement-bar', section => new AnnouncementBar(section), { lazy: true });
  sections.register('search', section => new TemplateSearch(section), { lazy: true });

  const rteElements = el.querySelectorAll('.rte');
  if (rteElements) {
    for (let i = 0; i < rteElements.length; i ++) {
      const rte = new Rte({ el: rteElements[i] });
    }
  }

  // Conditional views
  if (!el.classList.contains('template-password') && window.Pacific.settings['enable-sidebar']) {
    const sidebar = new Sidebar({ el: el.querySelector('.sidebar') });
  }
  if (el.getAttribute('class').indexOf('-customers-') > 0) {
    const templateAccount = new TemplateAccount({ el });
  }
  if (el.classList.contains('template-password')) {
    const templatePassword = new TemplatePassword({ el });
  }
  if (el.classList.contains('gift-card-template')) {
    const templateGiftCard = new TemplateGiftCard();
  }
};

if (polyfillUrls.length) {
  scriptjs(polyfillUrls, initPacific);
} else {
  initPacific();
}

